import {axios} from ".";
import config from '../config.json';

export const getAllCategory = async () => {
  try{
    const {
      data
    } = await axios.get(`${config.base_url_api}/category/`);
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
};


export const getCategoryByID = async(id) => {
  const {
      data
  } = await axios.get(`${config.base_url_api}/category/${id}`);
 return data;
};

export const createCategory = async(data) =>{
  const response =  await axios.post(`${config.base_url_api}/category/`, data);
  return response;
}


